export default __webpack_public_path__ + "img/FjaRvmXQ.9e5f190d.svg";